/** Calendar YYYY-MM-DD in the user's local timezone (avoids UTC shift from toISOString). */

export function dateToYmd(d) {
  if (!d || !(d instanceof Date) || Number.isNaN(d.getTime())) return null;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function parseYmdLocal(ymd) {
  const [y, m, d] = String(ymd).slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return null;
  const dt = new Date(y, m - 1, d);
  dt.setHours(0, 0, 0, 0);
  return Number.isNaN(dt.getTime()) ? null : dt;
}

export function startOfTodayLocal() {
  const t = new Date();
  t.setHours(0, 0, 0, 0);
  return t;
}

export function formatDisplayDate(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-US', {
    weekday: 'short',
    day: 'numeric',
    month: 'short'
  });
}

/**
 * Drop or adjust persisted ranges that are fully in the past or invalid.
 * @returns {{ checkInDate: Date, checkOutDate: Date } | null}
 */
export function sanitizeStoredDateRange(checkInDate, checkOutDate) {
  const today = startOfTodayLocal();
  let inDt =
    checkInDate instanceof Date && !Number.isNaN(checkInDate.getTime())
      ? new Date(checkInDate)
      : null;
  let outDt =
    checkOutDate instanceof Date && !Number.isNaN(checkOutDate.getTime())
      ? new Date(checkOutDate)
      : null;

  if (!inDt || !outDt) return null;

  inDt.setHours(0, 0, 0, 0);
  outDt.setHours(0, 0, 0, 0);

  if (outDt < today) return null;

  if (inDt < today) {
    inDt = new Date(today);
    if (outDt <= inDt) {
      outDt = new Date(inDt);
      outDt.setDate(outDt.getDate() + 1);
    }
  }

  if (outDt <= inDt) {
    outDt = new Date(inDt);
    outDt.setDate(outDt.getDate() + 1);
  }

  return { checkInDate: inDt, checkOutDate: outDt };
}
